var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useLabels, } from '@core-front/label-provider';
const NoticeCore = (props) => {
    const { type = 'info' } = props, rest = __rest(props, ["type"]);
    const labels = useLabels();
    return (React.createElement(NoticeCoreInner, Object.assign({}, rest, { type: type, labels: labels })));
};
export default NoticeCore;
class NoticeCoreInner extends React.Component {
    constructor() {
        super(...arguments);
        this.element = React.createRef();
    }
    BEM() {
        const classArray = ['notice'];
        if (this.props.type) {
            classArray.push('notice--' + this.props.type);
        }
        if (this.props.size) {
            classArray.push('notice--' + this.props.size);
        }
        if (this.props.align) {
            classArray.push('notice--' + this.props.align);
        }
        if (this.props.direction) {
            classArray.push('notice--' + this.props.direction);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    getIcon() {
        if (this.props.icon) {
            return this.props.icon;
        }
        switch (this.props.type) {
            case 'error':
                return '#alert';
            case 'success':
                return '#check-round';
            default:
                return '#info-round';
        }
    }
    render() {
        const { children, closeButtonLabel, components: { Icon }, id, labels, onCloseClick, isCloseButtonHidden, } = this.props;
        const buttonProps = isCloseButtonHidden ? {
            'aria-hidden': true,
            'tabIndex': -1,
        } : {};
        return (React.createElement("div", { className: this.BEM(), id: id, ref: this.element },
            React.createElement("div", { className: "notice__icon-cell" },
                React.createElement(Icon, { modifiers: this.getIcon(), className: "notice__icon" })),
            React.createElement("div", { className: "notice__content" },
                React.createElement("div", { className: "notice__inner-wrapper" },
                    React.createElement("div", { className: "notice__inner" }, children)),
                onCloseClick && (React.createElement("button", Object.assign({ type: "button", className: "notice__close", onClick: onCloseClick }, buttonProps),
                    React.createElement(Icon, { modifiers: "#close-round", className: "notice__close-icon" }),
                    !isCloseButtonHidden && React.createElement("span", { className: "sr-only" }, closeButtonLabel || labels.get('close')))))));
    }
}
